import React, { Component, createContext } from "react";
import Client from "shopify-buy";
// import _ from 'lodash';

const ShopContext = createContext();

const STOREFRONT_DOMAIN = "rcdepron.myshopify.com";
const STOREFRONT_ACCESS_TOKEN = "251729e85b2d4d5e111f8fd3a5f83e84";
const STOREFRONT_API_VERSION = "2024-04";

const client = Client.buildClient({
  storefrontAccessToken: STOREFRONT_ACCESS_TOKEN,
  domain: STOREFRONT_DOMAIN,
  apiVersion: "2023-07",
});

class ShopProvider extends Component {
  state = {
    product: {},
    products: [],
    collections: [],
    checkout: {},
    isCartOpen: false,
  };

  componentDidMount() {
    this.createCheckout();

    //Check if localStorage has a checkout_id saved
    // if (_.isEmpty(localStorage.checkout)) {
    //   this.fetchCheckout(localStorage.checkout);
    // } else {
    this.createCheckout();
    // }
    //if there is no checkout_id in localStorage then we will create a new checkout

    //else fetch the checkout from shopify
  }

  createCheckout = async () => {
    const checkout = await client.checkout.create();
    localStorage.setItem("checkout", checkout.id);
    await this.setState({ checkout: checkout });
  };

  fetchCheckout = async (checkoutId) => {
    client.checkout
      .fetch(checkoutId)
      .then((checkout) => {
        this.setState({ checkout: checkout });
      })
      .catch((err) => console.log(err));
  };

  addItemToCheckout = async (variantId, quantity) => {
    console.log("variantId", variantId);
    const lineItemsToAdd = [
      {
        variantId,
        quantity: parseInt(quantity, 10),
      },
    ];
    const checkout = await client.checkout.addLineItems(
      this.state.checkout.id,
      lineItemsToAdd
    );
    this.setState({ checkout: checkout });

    this.openCart();
  };

  removeItemFromCheckout = async (itemId, variantId, quantity, itemsLeft) => {
    let checkout;
    if (itemsLeft > 1) {
      checkout = await client.checkout.addLineItems(this.state.checkout.id, [
        { variantId, quantity: -1 },
      ]);
      this.setState({ checkout: checkout });
    }
    if (itemsLeft === 1) {
      try {
        checkout = await client.checkout.removeLineItems(
          this.state.checkout.id,
          [itemId]
        );
        this.setState({ checkout: checkout });
      } catch (e) {
        console.log("e", e);
      }
    } else {
      console.log("too many clicks");
    }
  };

  fetchAllProducts = async () => {
    const products = await client.product.fetchAll();
    this.setState({ products });
  };

  storefrontQuery = async (query, variables = {}) => {
    const response = await fetch(
      `https://${STOREFRONT_DOMAIN}/api/${STOREFRONT_API_VERSION}/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query, variables }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const json = await response.json();
    if (json?.errors?.length) {
      // Keep the UI working even if Shopify returns partial errors.
      console.error("Storefront API errors:", json.errors);
    }
    return json;
  };

  normalizeStorefrontProduct = (productNode) => {
    if (!productNode) return null;

    return {
      id: productNode.id,
      title: productNode.title,
      handle: productNode.handle,
      description: productNode.description,
      descriptionHtml: productNode.descriptionHtml,
      availableForSale: productNode.availableForSale,
      images:
        productNode.images?.edges?.map((edge) => ({
          src: edge.node.url,
          altText: edge.node.altText,
        })) || [],
      variants:
        productNode.variants?.edges?.map((edge) => ({
          id: edge.node.id,
          title: edge.node.title,
          sku: edge.node.sku,
          availableForSale: edge.node.availableForSale,
          price: {
            amount: edge.node.price.amount,
            currencyCode: edge.node.price.currencyCode,
          },
        })) || [],
    };
  };

  fetchAllCollections = async () => {
    const GET_COLLECTIONS = `
      query getCollections($first: Int!, $after: String) {
        collections(first: $first, after: $after) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              handle
              descriptionHtml
              image {
                url
                altText
              }
            }
          }
        }
      }
    `;

    const GET_COLLECTION_PRODUCTS = `
      query getCollectionProducts($handle: String!, $first: Int!, $after: String) {
        collectionByHandle(handle: $handle) {
          products(first: $first, after: $after) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                title
                handle
                description
                descriptionHtml
                availableForSale
                images(first: 10) {
                  edges {
                    node {
                      url
                      altText
                    }
                  }
                }
                variants(first: 25) {
                  edges {
                    node {
                      id
                      title
                      sku
                      availableForSale
                      price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const allCollections = [];
      let after = null;
      let hasNextPage = true;

      while (hasNextPage) {
        const response = await this.storefrontQuery(GET_COLLECTIONS, {
          first: 250,
          after,
        });
        const connection = response?.data?.collections;
        const edges = connection?.edges || [];

        edges.forEach((edge) => {
          const node = edge?.node;
          if (!node) return;
          allCollections.push({
            id: node.id,
            title: node.title,
            handle: node.handle,
            descriptionHtml: node.descriptionHtml,
            image: node.image
              ? { src: node.image.url, altText: node.image.altText }
              : null,
          });
        });

        hasNextPage = Boolean(connection?.pageInfo?.hasNextPage);
        after = connection?.pageInfo?.endCursor || null;
      }

      const hydratedCollections = [];

      for (const collection of allCollections) {
        const products = [];
        let productsAfter = null;
        let productsHasNext = true;

        while (productsHasNext) {
          const response = await this.storefrontQuery(GET_COLLECTION_PRODUCTS, {
            handle: collection.handle,
            first: 250,
            after: productsAfter,
          });

          const productsConn =
            response?.data?.collectionByHandle?.products || null;

          const edges = productsConn?.edges || [];
          edges.forEach((edge) => {
            const normalized = this.normalizeStorefrontProduct(edge?.node);
            if (normalized) products.push(normalized);
          });

          productsHasNext = Boolean(productsConn?.pageInfo?.hasNextPage);
          productsAfter = productsConn?.pageInfo?.endCursor || null;
        }

        hydratedCollections.push({
          ...collection,
          products,
        });
      }

      this.setState({ collections: hydratedCollections });
    } catch (error) {
      console.error("Error fetching collections:", error);
    }
  };

  fetchProductWithId = async (id) => {
    const product = await client.product.fetch(id);
    this.setState({ product: product });

    return product;
  };

  closeCart = () => {
    this.setState({ isCartOpen: false });
  };
  openCart = () => {
    this.setState({ isCartOpen: true });
  };

  render() {
    return (
      <ShopContext.Provider
        value={{
          ...this.state,
          fetchAllProducts: this.fetchAllProducts,
          fetchAllCollections: this.fetchAllCollections,
          fetchProductWithId: this.fetchProductWithId,
          closeCart: this.closeCart,
          openCart: this.openCart,
          addItemToCheckout: this.addItemToCheckout,
          removeItemFromCheckout: this.removeItemFromCheckout,
        }}
      >
        {this.props.children}
      </ShopContext.Provider>
    );
  }
}

const ShopConsumer = ShopContext.Consumer;

export { ShopConsumer, ShopContext };

export default ShopProvider;
